<template>
  <v-container>
    <v-row v-if="customer">
      <v-col>
        <v-card class="d-flex align-center justify-center flex-column pa-5">
          <v-avatar size="70">
            <img
              v-if="this.customer.logo"
              :src="this.customer.logo"
              style="width: 100%; height: 100%;"
            />
            <img
              v-else
              :src="defaultImage"
              style="width: 100%; height: 100%;"
            />
          </v-avatar>
          <v-card-text>
            <v-list dense disabled>
              <v-list-item-group class="d-flex  flex-column justify-center">
                <v-list-item
                  class="my-4"
                  style="border: none;"
                  v-if="this.customer.company_name"
                >
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">double_arrow</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label"
                      >Company Name</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      this.customer.company_name
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="border-opacity-25"></v-divider>
                <v-list-item
                  class="my-4"
                  style="border: none;"
                  v-if="this.customer.first_name || this.customer.last_name"
                >
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">double_arrow</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label"
                      >Contact Person</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value"
                      >{{ this.customer.title }}.
                      {{ this.customer.first_name }}
                      {{ this.customer.last_name }}</v-col
                    >
                  </v-row>
                </v-list-item>
                <v-divider class="border-opacity-25"></v-divider>
                <v-list-item
                  class="my-4"
                  style="border: none;"
                  v-if="this.customer.email"
                >
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">double_arrow</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Email</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      this.customer.email
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="border-opacity-25"></v-divider>
                <v-list-item
                  class="my-4"
                  style="border: none;"
                  v-if="this.customer.mobile"
                >
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">double_arrow</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Mobile</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      this.customer.mobile
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="border-opacity-20"></v-divider>
                <v-list-item
                  class="my-4"
                  style="border: none;"
                  v-if="this.customer.phone"
                >
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">double_arrow</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Phone</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      this.customer.phone
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="border-opacity-20"></v-divider>
                <v-list-item
                  class="my-4"
                  style="border: none;"
                  v-if="
                    this.customer.address1 ||
                      this.customer.city ||
                      this.customer.state ||
                      this.customer.country
                  "
                >
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">double_arrow</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Address</v-col>
                    <v-col xs="12" md="8" class="detail-value">
                      {{
                        [
                          customer.address1,
                          customer.city,
                          customer.state,
                          customer.country,
                        ]
                          .filter(Boolean)
                          .join(", ") || "-"
                      }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-alert type="info">No customer information available.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { filters } from "../../utility/filters";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { CustomerService } from "@/services/customer-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "CustomerInfo",
  data() {
    return {
      customer: {},
      projects: [],
      loading: false,
      defaultImage: require("@/assets/img/avatar.svg"),
    };
  },

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getCustomerInfo();
  },

  methods: {
    getCustomerInfo() {
      this.loading = true;
      CustomerService.getCustomerInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.customer = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.customer = {};
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },
  },
};
</script>
<style>
.profile-avatar {
  text-align: center;
  padding: 5px;
}

.profile-avatar .v-card__title {
  align-items: center;
  display: grid;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}

.icon-box {
  border-radius: 30%;
}
.detail-label {
  font-weight: 500;
  color: black;
}
.detail-value {
  color: #555;
  font-weight: 400;
}
</style>
